import { createAsyncThunk } from '@reduxjs/toolkit';
import { OfferingDocumentGroup } from '../../../../model/documents/offering-document-group';
import documentsRepository from '../../../../repositories/documents/documents-repository';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import { OfferingDocumentsError } from './offerings-types';

export const downloadOfferDocuments = createAsyncThunk<
  OfferingDocumentGroup[],
  void,
  AsyncThunkConfig<OfferingDocumentsError>
>('download-offer-documents', async (_, thunkApi) => {
  try {
    return await documentsRepository.getOfferDocuments(thunkApi);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
